import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgIllnessFever = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.0175 5.125C5.39917 7.0725 4.47583 9.95833 3.2925 13.025C3.25617 13.1197 3.2434 13.2218 3.2553 13.3226C3.26719 13.4233 3.3034 13.5197 3.3608 13.6033C3.4182 13.6869 3.49507 13.7554 3.58479 13.8027C3.67451 13.85 3.77439 13.8748 3.87583 13.875H5.45917V16.375C5.45917 17.038 5.72256 17.6739 6.1914 18.1428C6.66024 18.6116 7.29613 18.875 7.95917 18.875H9.20917V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9592 21.375V16.1542C18.7116 15.4578 19.3192 14.62 19.7474 13.6885C20.1756 12.7571 20.4159 11.7504 20.4546 10.726C20.4933 9.70158 20.3296 8.67959 19.973 7.71851C19.6163 6.75743 19.0736 5.87612 18.3759 5.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4592 2.625C9.2092 5.125 12.3342 5.125 11.0842 7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5324 2.625C13.2824 5.125 16.4074 5.125 15.1574 7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgIllnessFever.displayName = 'SvgIllnessFever';
export default SvgIllnessFever;
